export default {
  HOME_PAGE_URL: 'http://www.johnlewis.com',
  BASKET_PAGE_URL: 'http://www.johnlewis.com/basket',
  GOOGLEMAPS_API_URL: 'https://maps.googleapis.com/maps/api/js?key=',
};
